import { ComparisonTableFields } from '@bw/apis/contentful';
import { cn } from '@bw/core';
import { Block } from "../../factories/types";
import { defined } from '../../utils/defined';
import { RichText } from '../../utils/rich-text/RichText';
import styles from "./ComparisonTable.module.scss";

type Context = {
  comparisonPoints: ComparisonTableFields['comparisonPoints'];
}

export const ComparisonColumn: Block<'comparisonColumn', Context> = ({
  data: {
    fields: {
      headerTitle,
      header,
      comparisonItems
    }
  },
  render,
  fieldId,
  context
}) =>
  <li>
    <div className={cn(styles.head, 'soft-secondary')}>
      <h3 data-aos="fade-up" {...fieldId('headerTitle')}>
        {headerTitle}
      </h3>
      <div data-aos="fade-up" {...fieldId('header')}>
        <RichText document={header} />
      </div>
    </div>
    {defined(comparisonItems).map((row, index) =>
      <div key={index} className={cn(styles.row, 'default')}>
        {context?.comparisonPoints && (
          <div className={styles.title} data-aos="fade-up">
            {render(context?.comparisonPoints[index])}
          </div>
        )}

        {render(row, { 'data-aos': 'fade-up' })}
      </div>
    )}
  </li>
